import { getObjectByKeys } from '../../helpers';
import { useGlobalStore } from '../index';

import type { SessionInterface } from 'sonata-static-storage/lib/schemas/session/session.schema';
import type { GlobalStore } from '../index';

// SETTERS
export const setSession = useGlobalStore.getState().setSession;

// REMOVERS
export const removeSession = useGlobalStore.getState().removeSession;

// GETTERS
export const getSession = (store: GlobalStore) => {
  const { session } = store;
  return session;
};

export const getSessionByKeys = ({ session }: GlobalStore, keys: (keyof SessionInterface)[]) => {
  if (session && Object.keys(session).length > 0) {
    return getObjectByKeys(session.toJSON(), keys);
  }
  return {};
};
